import { useEffect, useRef, useState } from "react";
import "./chat-history.component.scss";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../hooks/useApi";
import { Tooltip } from "react-tooltip";
import {
  hideLoading,
  hideUserManagementScreen,
  setInteractionValue,
  showError,
  showLoading,
  showRecommendedQuestions,
  showUserManagementScreen,
} from "../../state/slice";
import useScreenSize from "../../hooks/useScreenSize";
import useUser from "../../hooks/useUser";

const ChatHistory = (props: any) => {
  const [expanded, setExpanded] = useState(false);
  const sidebarClass = props?.isOpen ? "sidebar open" : "sidebar";
  const mainlogoOnly = require("../../assets/world-cc-logo-only.ico");
  const mainlogo = require("../../assets/world-cc-logo.svg")?.default;
  const userLogo = require("../../assets/person-fill-add.svg")?.default;

  // const mobileHamburgerLogo =
  //   require("../../assets/hamburger-icon.svg")?.default;

  const newChatLogo = require("../../assets/new-chat.svg")?.default;
  // const newChatExpandedLogo =
  //   require("../../assets/new-chat-expanded-color.svg")?.default;

  const collapseLogo =
    require("../../assets/expand-sidebar-flipped.svg")?.default;
  const expandLogo = require("../../assets/expand-sidebar.svg")?.default;
  const { get } = useApi();
  const currentUser = useSelector((state: any) => state.user);

  const dispatch = useDispatch();
  const [historyData, setHistoryData] = useState<any>([]);
  const [selectedChat, setSelectedChat] = useState("");
  const showAnswer = useSelector((state: any) => state.showAnswer);
  const { isMobile } = useScreenSize();
  const tooltipRef = useRef(null);
  const isUserScreenAllowed = useUser();

  useEffect(() => {
    const fetchData = async () => {
      setHistoryData([]);
      const url2 = `interactions/by_user/${currentUser?.id}`;

      // const url2 = `http://localhost:8080/interactions/email/dimple@dandilion.ai`;
      try {
        const response: any = await get(url2);
        if (response) {
          setHistoryData(response.data);
        }
      } catch (error) {
        // console.log("error==>", error);
        //   setLoading(false);
        // Handle other errors
      }
    };
    if (currentUser || showAnswer) fetchData();
    setSelectedChat("");
  }, [currentUser, showAnswer]);

  const fetchIterationHistoryForSelectedSessionQuestion = (item) => {
    dispatch(showLoading());
    setSelectedChat(`idli${item.interaction_id}`);
    fetchInteractionById(item.interaction_id);
    dispatch(hideUserManagementScreen());
    if (isMobile) {
      props.toggleSidebar();
    }
  };

  useEffect(() => {}, [isMobile]);

  const fetchInteractionById = async (id) => {
    try {
      const response: any = await get(`interactions/${id}`);
      if (response?.status === 200) {
        const payload = {
          question: response.data.question,
          answer: response.data.response,
          sources: response.data.source_associations?.map(
            ({ source, ...rest }) => ({
              ...rest,
              content_delta: source,
            })
          ),
          chatHistoryId: id,
          feedback: response.data.feedbacks,
        };
        dispatch(setInteractionValue(payload));
        dispatch(showRecommendedQuestions());
        dispatch(hideLoading());
      } else {
        dispatch(showError());
      }
    } catch (error) {
      console.log("error while fetcing individual interaction==>", error);
      //   setLoading(false);
      // Handle other errors
      dispatch(showError());
    }
  };

  useEffect(() => {
    setExpanded(!expanded);
  }, [props?.sidebarOpen]);

  const handleMouseLeave = () => {
    // Use this to force-hide the tooltip
    if (tooltipRef.current) {
      tooltipRef.current.close();
    }
  };

  const renderHistoryPerArray = (key, arrayname) => {
    if (arrayname?.length === 0) return null;
    return (
      <>
        <div className="group" key={key}>
          <p className="dayName">{formatGroupName(key)}</p>
          <ul style={{ margin: "0px", padding: "0px" }}>
            {arrayname
              ?.filter((e) => {
                return e.query?.toString()?.trim() !== "";
              })
              .map((item) => (
                <li
                  className={`truncated ${
                    selectedChat === `idli${item.interaction_id}`
                      ? "selected"
                      : ""
                  }`}
                  key={item.interaction_id}
                  id={`idli${item.interaction_id}`}
                  onClick={() =>
                    fetchIterationHistoryForSelectedSessionQuestion(item)
                  }
                  onMouseLeave={() => {
                    (
                      document.querySelector(
                        `#idli${item.interaction_id}`
                      ) as HTMLElement
                    )?.blur();
                  }}
                >
                  {item.query}
                  {!isMobile && (
                    <Tooltip
                      ref={tooltipRef}
                      className="tooltipclas"
                      anchorSelect={`#idli${item.interaction_id}`}
                      place="right"
                    >
                      <p>{item.query}</p>
                    </Tooltip>
                  )}
                </li>
              ))}
          </ul>
        </div>
      </>
    );
  };

  const formatGroupName = (text: string) => {
    const match = text.match(/^\d{4}-\d{2}$/); // exact match, entire text is a date like '2025-05'
    if (match) {
      const [year, month] = text.split("-");
      const date = new Date(`${year}-${month}-01`);
      return date.toLocaleString("default", {
        month: "short",
        year: "numeric",
      });
    }
    return text
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getOtherHistoryData = () => {
    if (historyData.others && historyData.others != null) {
      const isEmpty = Object.keys(historyData.others).length === 0;
      if (isEmpty) return null;

      return Object.entries(historyData.others)
        .filter(([key, value]) => Array.isArray(value) && value.length > 0) // Filter non-empty arrays
        .map(([key, value]) => renderHistoryPerArray(key, value));
    }
    return null;
  };

  const getHistoryData = () => {
    return (
      <div className="historyData" onMouseLeave={handleMouseLeave}>
        <>
          {historyData
            ? renderHistoryPerArray("today", historyData.today)
            : null}
          {historyData
            ? renderHistoryPerArray("yesterday", historyData.yesterday)
            : null}
          {historyData
            ? renderHistoryPerArray("previous 7 days", historyData.last_week)
            : null}
          {historyData
            ? renderHistoryPerArray(
                "previous 30 days",
                historyData.last_30_days
              )
            : null}
          {historyData ? getOtherHistoryData() : null}
        </>
      </div>
    );
  };

  const gotoUserManagementScreen = () => {
    setSelectedChat("");

    dispatch(showUserManagementScreen());
  };

  const renderExpandedVersionDesign = () => {
    return (
      <div className="sidebar-header">
        <div className="sidebar-header-left">
          <img src={mainlogo} alt="worldcc" width="110px" height="30px"></img>
        </div>
        <div className="sidebar-header-right">
          {isUserScreenAllowed && (
            <button
              onClick={gotoUserManagementScreen}
              className="newchat"
              title="User Management"
            >
              <img
                src={userLogo}
                alt="User Management"
                height="31px"
                width="34px"
              ></img>
            </button>
          )}
          <button
            onClick={openNewChatInDashBoard}
            className="newchat"
            title="New Chat"
          >
            <img
              src={newChatLogo}
              alt="newsession"
              height="31px"
              width="34px"
            ></img>
          </button>

          <button
            onClick={props.toggleSidebar}
            className="collapsesidebar"
            title="Close"
          >
            <img
              src={collapseLogo}
              alt="collapse"
              height="30px"
              width="39px"
            ></img>
          </button>
        </div>
      </div>
    );
  };

  const renderCollapsedView = () => {
    return isMobile
      ? renderMobileExpandedDesign()
      : renderExpandedVersionDesign();
  };
  const renderExpandedView = () => {
    return isMobile
      ? renderMobileCollapsedDesign()
      : renderCollapsedVersionDesign();
  };

  const renderCollapsedVersionDesign = () => {
    return (
      <div className="sidebar-header collapsedView">
        <button className="collapsesidebar">
          <img
            src={mainlogoOnly}
            alt="worldcc"
            width="34px"
            height="31px"
          ></img>
        </button>

        <button
          onClick={props.toggleSidebar}
          className="expandsidebar"
          title="Chat History"
        >
          <img src={expandLogo} alt="expand" height="30px" width="39px"></img>
        </button>

        <button
          onClick={props.openNewChat}
          className="newchat"
          title="New Chat"
        >
          <img
            src={newChatLogo}
            alt="newsession"
            height="31px"
            width="34px"
          ></img>
        </button>
        {isUserScreenAllowed && (
          <button
            onClick={gotoUserManagementScreen}
            className="newchat"
            title="User Management"
          >
            <img
              src={userLogo}
              alt="User Management"
              height="31px"
              width="34px"
            ></img>
          </button>
        )}
      </div>
    );
  };

  const renderMobileExpandedDesign = () => {
    return (
      <div className="mobile">
        <div className="sidebar-header mobile">
          <button className="collapsesidebar">
            <img
              src={collapseLogo}
              alt="worldcc"
              width="30px"
              height="30px"
              onClick={props.toggleSidebar}
            ></img>
          </button>
          <button className="collapsesidebar btntitle">
            <img
              src={mainlogoOnly}
              alt="worldcc"
              width="30px"
              height="30px"
            ></img>{" "}
            Chat History
          </button>
          <button
            onClick={openChatInDashBoard}
            className="newchat"
            title="New Chat"
          >
            <img
              src={newChatLogo}
              alt="newsession"
              height="25px"
              width="25px"
            ></img>
          </button>
        </div>
      </div>
    );
  };

  const openChatInDashBoard = () => {
    props.openNewChat();
    props.toggleSidebar();
    setSelectedChat("");
  };

  const openNewChatInDashBoard = () => {
    props.openNewChat();
    setSelectedChat("");
  };
  const renderMobileCollapsedDesign = () => {
    return (
      <div className="sidebar-header collapsedView mobile">
        <button className="collapsesidebar">
          <img
            src={expandLogo}
            alt="worldcc"
            width="30px"
            height="30px"
            onClick={props.toggleSidebar}
          ></img>
        </button>
      </div>
    );
  };

  const renderForm = () => {
    return (
      <div className={`${isMobile ? "mobilesidebar" : ""} ${sidebarClass} `}>
        {!expanded && renderCollapsedView()}
        {expanded && renderExpandedView()}
        {getHistoryData()}
      </div>
    );
  };

  return renderForm();
};

export default ChatHistory;
